import React, { FC } from 'react';
import { ContactUs } from './contact-us';

import {
  MailOutline,
  PhoneOutlined,
  LocationOnOutlined,
  HeadsetMicOutlined,
  BusinessOutlined
} from "@mui/icons-material";

export const ContactUsContainer: FC = () => {

  const contactItems = [
    {
      icon: <MailOutline />,
      label: 'Email',
      value: 'ouvidoria@es.gov.br',
    },
    {
      icon: <PhoneOutlined />,
      label: 'Telefone',
      value: '0800 022 11 17',
    },
    {
      icon: <HeadsetMicOutlined />,
      label: 'Atendimento Online',
      value: '9h às 18h',
    },
    {
      icon: <LocationOnOutlined />,
      label: 'Endereço',
      value: 'Av. Governador Bley, 236 - Ed. Fábio Ruschi, 6º andar Centro Vitória/ ES - Cep: 29010 - 150',
    },
    {
      icon: <BusinessOutlined />,
      label: 'Atendimento Presencial',
      value: '9h às 16h',
    },
  ];

  return (
    <div>
      <ContactUs items={contactItems} />
    </div>
  );
};